import { render, staticRenderFns } from "./r-item-order-dropdown-dialog.vue?vue&type=template&id=c1033a54&scoped=true"
import script from "./r-item-order-dropdown-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-order-dropdown-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-order-dropdown-dialog.vue?vue&type=style&index=0&id=c1033a54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1033a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1033a54')) {
      api.createRecord('c1033a54', component.options)
    } else {
      api.reload('c1033a54', component.options)
    }
    module.hot.accept("./r-item-order-dropdown-dialog.vue?vue&type=template&id=c1033a54&scoped=true", function () {
      api.rerender('c1033a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-order/r-item-order-dropdown-dialog.vue"
export default component.exports